import React from "react";
import { Navigate, Outlet } from "react-router-dom";

export const MentorPrivateRoute = () => {
  // If authorized, return an outlet that will render child elements
  // If not, return element that will navigate to login page
  if(localStorage.getItem("role")) {
    if(localStorage.getItem("role") === "69b40b2c-feeb-4ab5-afe2-87694b8f61cf") return <Outlet />
    }
    localStorage.clear();
    return <Navigate to="/login" />
};